import { config } from "../../Config";

const getExtension = async (userId, extensionId) => {
    const baseUrl = config.getExtensionById;
    const url = `${baseUrl}`;
    if (!userId) {
        throw new Error("The 'userId' parameter is required.");
    }

    if (!extensionId) {
        throw new Error("The 'extensionId' parameter is required.");
    }

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ userId, extensionId })
        });

        if (!response.ok) {
            if (response.status === 400) {
                const errorText = await response.text();
                throw new Error(`Bad Request: ${errorText}`);
            } else if (response.status === 404) {
                const errorData = await response.json();
                throw new Error(`Not Found: ${errorData.message}`);
            } else {
                throw new Error(`Error: ${response.status} ${response.statusText}`);
            }
        }

        const data = await response.json();
        return data;
    } catch (error) {
        // console.error('Error fetching extension details:', error);
        throw error;
    }
};

export default getExtension;
